import React from "react";
import Btn from "./btn";
import type { ToggleBtnProps } from "./btn/Toggle";

export interface ToggleGroupProps
  extends Omit<ToggleBtnProps, "on" | "children"> {
  isLeft?: boolean;
  leftValue?: string;
  leftLabel?: string;
  rightValue?: string;
  rightLabel?: string;
  onClick?: (string) => void;
}

const Toggle: React.FC<ToggleGroupProps> = ({
  isLeft = true,
  leftValue = "left",
  rightValue = "right",
  leftLabel = "왼쪽",
  rightLabel = "오른쪽",
  onClick,
  ...props
}) => {
  return (
    <div className="w-fit bg-[#f7f7f7] border border-[#eeeeee] rounded-[40px] flex items-center justify-center">
      <Btn.Toggle
        {...props}
        on={isLeft}
        children={leftLabel}
        onClick={() => onClick && onClick(leftValue)}
      />
      <Btn.Toggle
        {...props}
        on={!isLeft}
        children={rightLabel}
        onClick={() => onClick && onClick(rightValue)}
      />
    </div>
  );
};

export default Toggle;
